import axios from "axios";
import NProgress from "nprogress";
import { config } from "./config";
import { toastify } from "./toast";
import { Persistor } from "src/redux/store";
import { getLoginPath } from "src/utils/authPortal";

let isToastShown = false;
const SESSION_REDIRECT_DELAY_MS = 2200;
const SESSION_EXPIRED_MESSAGE =
  "Your session expired. Redirecting you to login securely...";

const AUTH_URL_PATTERNS = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/mailing-list",
  "/tos/accept",
  "/canva/get/designs",
];

const isAuthRequest = (error) => {
  const url = String(error?.config?.url || "").toLowerCase();
  const isKnownPublicOrAuthRoute = AUTH_URL_PATTERNS.some((pattern) =>
    url.includes(pattern),
  );
  const isEtsyRelatedRequest = url.includes("/etsy/") || url.includes("etsy/");
  const isEtsyProductLinkingRequest = url.includes("/products/") && url.includes("etsy");
  const isPaymentCaptureRequest = url.includes("/payments/capture");

  return (
    isKnownPublicOrAuthRoute ||
    isEtsyRelatedRequest ||
    isEtsyProductLinkingRequest ||
    isPaymentCaptureRequest
  );
};

const isAuthenticatedAppPath = () => {
  const path = window.location.pathname || "";
  return path.startsWith("/dashboard");
};

const isSessionExpiredError = (error) => {

  if (isAuthRequest(error)) return false;
  if (!localStorage.getItem("token")) return false;


  if (!isAuthenticatedAppPath()) return false;

  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || "").trim();


  return (
    status === 401 &&
    (message === "Unauthenticated" || message === "Unauthenticated.")
  );
};

const clearSessionAndRedirect = async () => {
  // Clear persisted Redux store first to avoid stale rehydration on login.
  await Persistor.purge();

  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("etsyLoadedStatuses");
  localStorage.removeItem("etsyResyncTimestamp");
  localStorage.removeItem("lastEtsyOffset");
  localStorage.removeItem("oAuth");
  localStorage.removeItem("expiresIn");
  localStorage.removeItem("etsyStore");
  localStorage.removeItem("amazonStore");
  localStorage.removeItem("lastEtsyFetch");
  localStorage.removeItem("lastAmazonFetch");
  sessionStorage.clear();

  window.location.href = getLoginPath();
};

const request = axios.create({
  baseURL: config.apiUrl,
  timeout: 20 * 60 * 1000,
});
// debugger;

request.interceptors.request.use(
  (config) => {
    config.headers.Authorization = localStorage.getItem("token")
      ? `Bearer ${localStorage.getItem("token")}`
      : "";
    if (!config.silent) {
      NProgress.start();
    }
    return config;
  },
  (error) => {
    if (!error?.config?.silent) {
      NProgress.done();
    }

    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    if (!response?.config?.silent) {
      NProgress.done();
    }
    return response;
  },
  (error) => {
    if (!error?.config?.silent) {
      NProgress.done();
    }

    if (error.code === "ECONNABORTED") {
      toastify("error", `${error.message}. Please try again`);
    }

    if (error?.config?.skipAuthRedirect) {
      return Promise.reject(error);
    }

    if (isSessionExpiredError(error)) {
      error.isSessionExpired = true;
      if (!isToastShown) {
        toastify("warning", SESSION_EXPIRED_MESSAGE);
        isToastShown = true;
        setTimeout(clearSessionAndRedirect, SESSION_REDIRECT_DELAY_MS);
      }
    }

    return Promise.reject(error);
  }
);

export default request;
